<template>
    <div class="animated fadeIn container-fluid page-content">
        <SectionTitle :title="'Tin cảnh báo'" class="cursor-pointer" @click="goToAllItemScreen('warning')" />
        <div class="text-right">
            <b-button variant="link" @click="goToAllItemScreen('warning')"><b>Xem thêm</b></b-button>
        </div>
        <div class="text-center" v-if="!listWarningNewsDisplay.length">Không có bản tin nào</div>
        <b-row v-else class="mx-2">
            <b-col sm="6" md="4" lg="3" xl="2" v-for="(item, index) in listWarningNewsDisplay" :key="index">
                <b-card border-variant="light" :img-src="item.avatar
                    ? `${API_CONFIG.URL_GET_FILE}${item.avatar}`
                    : '/img/image_news.jpeg'
                    " img-alt="Ảnh" class="card-doc cursor-pointer" img-top img-height="190px"
                    @click="getInfo(item.id)">
                    <b-card-text class="font-weight-bold document-content text-primary">{{
                        item.name
                        }}</b-card-text>
                    <b-card-text class="text-muted">{{ item.date | formatDate }}</b-card-text>
                </b-card>
            </b-col>
        </b-row>

        <SectionTitle :title="'Tin thường'" class="cursor-pointer" @click="goToAllItemScreen('normal')" />
        <div class="text-right">
            <b-button variant="link" @click="goToAllItemScreen('normal')"><b>Xem thêm</b></b-button>
        </div>
        <div class="text-center mb-2" v-if="!listNormalNewsDisplay.length">
            Không có bản tin nào
        </div>
        <b-row v-else class="mx-2">
            <b-col sm="6" md="4" lg="3" xl="2" v-for="(item, index) in listNormalNewsDisplay" :key="index">
                <b-card border-variant="light" :img-src="item.avatar
                    ? `${API_CONFIG.URL_GET_FILE}${item.avatar}`
                    : '/img/image_news.jpeg'
                    " img-alt="Ảnh" img-top class="card-doc cursor-pointer" img-height="190px"
                    @click="getInfo(item.id)">
                    <b-card-text class="font-weight-bold document-content text-primary">{{
                        item.name
                        }}</b-card-text>
                    <b-card-text class="text-muted">{{ item.date | formatDate }}</b-card-text>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle';
import CONSTANTS from '@/constants';
import { mapState, mapActions } from 'vuex';
import API_CONFIG from '@/api-config';

export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            newsId: null,
            CONSTANTS,
            API_CONFIG
        };
    },
    computed: {
        ...mapState({
            listNews: state => state.news.items
        }),
        listWarningNewsDisplay() {
            let listData = this.listNews.filter(
                item => item.status == 'PUBLISH' && item.type == 'WARNING'
            );
            return listData.sort((a, b) => this.compareDate(a, b)).slice(0, 6);
        },
        listNormalNewsDisplay() {
            let listData = this.listNews.filter(
                item => item.status == 'PUBLISH' && item.type == 'NORMAL'
            );
            return listData.sort((a, b) => this.compareDate(a, b)).slice(0, 6);
        }
    },
    created() {
        this.getListNews();
    },
    methods: {
        ...mapActions({
            getListNews: 'news/getList'
        }),
        getInfo(newsId) {
            this.$router.push(`/news/${newsId}`);
        },
        goToAllItemScreen(type) {
            this.$router.push(`/all-news`);
        },
        compareDate(a, b) {
            if (this.$moment(a.date).isAfter(this.$moment(b.date))) return -1;
            if (this.$moment(a.date).isBefore(this.$moment(b.date))) return 1;
            return 0;
        }
    }
};
</script>
<style lang="scss">
.card-doc {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);

    .station-icon {
        background: lightskyblue;
        width: 35px;
        height: 35px;
        padding: 8px 12px;
        border-radius: 4px;
    }

    .station-name {
        font-size: 1.5rem;
        font-weight: 600;
    }

    .document-content {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 58px;
    }

    .title-content {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 35px;
    }
}

@media screen and (min-width: 1025px) {
    .page-content {
        padding: 0px 120px;
    }
}

@media screen and (max-width: 500px) {
    .page-content {
        padding: 0px;

        .fit-page-row {
            margin: 0px !important;

            .fit-page-col {
                padding: 0px !important;
            }
        }
    }
}
</style>
